import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@tcp/cloudia-utilities';

@Component({
  selector: 'cloudia-cookie-policy-page',
  templateUrl: './cookie-policy-page.component.html',
  styleUrls: ['./cookie-policy-page.component.scss'],
})
export class CookiePolicyPageComponent extends BaseComponent implements OnInit {
  tenant: string;
  protected necassaryCookies = [
    {
      name: 'KEYCLOAK_SESSION_LEGACY',
      duration: '1 year',
      description: 'ID of the current browser session.',
    },
    {
      name: 'KEYCLOAK_IDENTITY_LEGACY',
      duration: 'Expires with Session',
      description: 'Contains a token with the authenticated user id.',
    },
    {
      name: 'KEYCLOAK_IDENTITY',
      duration: 'Expires with Session',
      description: 'Contains a token with the authenticated user id.',
    },
    {
      name: 'KEYCLOAK_SESSION',
      duration: '1 year',
      description: 'ID of the current browser session.',
    },
    {
      name: 'AUTH_SESSION_ID_LEGACY',
      duration: 'Expires with Session',
      description: 'ID of the current authentication session.',
    },
    {
      name: 'AUTH_SESSION_ID',
      duration: 'Expires with Session',
      description: 'ID of the current authentication session.',
    },
  ];

  protected analyticalCookies = [
    {
      name: '_ga',
      duration: '1 year',
      description:
        // eslint-disable-next-line max-len
        `Used by Google Analytics to calculate visitor and session data, and to keep track of site usage for the site's analytics report. The cookie stores information anonymously and assigns a randomly generated number to recognize unique visitors.`,
    },
    {
      name: '_ga_<container-id>',
      duration: '1 year',
      description: 'Used by Google Analytics to persist session state.',
    },
    {
      name: '_hjSessionUser_<site_id>',
      duration: '1 year',
      description:
        // eslint-disable-next-line max-len
        'Set when a user first lands on a page. Persists the Hotjar User ID which is unique to that site. Hotjar does not track users across different sites. Ensures data from subsequent visits to the same site are attributed to the same user ID.',
    },
    {
      name: '_hjFirstSeen',
      duration: '30 minutes',
      description:
        'Identifies a new user’s first session. Used by Recording filters to identify new user sessions.',
    },
    {
      name: '_hjHasCachedUserAttributes',
      duration: 'Session',
      description:
        'Enables us to know whether the data set in _hjUserAttributes Local Storage item is up to date or not.',
    },
    {
      name: '_hjUserAttributesHash',
      duration: '2 minutes',
      description:
        'Enables us to know when any User Attribute has changed and needs to be updated.',
    },
    {
      name: '_hjSession_<site_id>',
      duration: '30 minutes',
      description:
        'Holds current session data. Ensures subsequent requests in the session window are attributed to the same session',
    },
    {
      name: '_hjSessionTooLarge',
      duration: '1 hour',

      description:
        // eslint-disable-next-line max-len
        'Causes Hotjar to stop collecting data if a session becomes too large. Determined automatically by a signal from the server if the session size exceeds the limit.',
    },
    {
      name: '_hjSessionResumed',
      duration: 'Session',
      description:
        'Set when a session/recording is reconnected to Hotjar servers after a break in connection.',
    },
    {
      name: '_hjCookieTest',
      duration: 'less than second',
      description:
        'Checks to see if the Hotjar Tracking Code can use cookies. Deleted almost immediately after it is created.',
    },
    {
      name: '_hjLocalStorageTest',
      duration: 'less than second',
      description:
        // eslint-disable-next-line max-len
        'Checks if the Hotjar Tracking Code can use Local Storage. Data stored in _hjLocalStorageTest has no expiration time, but it is deleted almost immediately after it is created.',
    },
    {
      name: '_hjSessionStorageTest',
      duration: 'less than second',

      description:
        // eslint-disable-next-line max-len
        'Checks if the Hotjar Tracking Code can use Session. Data stored in _hjSessionStorageTest has no expiration time, but it is deleted almost immediately after it is created.',
    },
    {
      name: '_hjIncludedInPageviewSample',
      duration: '2 minutes',
      description: `Set to determine if a user is included in the data sampling defined by your site's pageview limit`,
    },
    {
      name: '_hjIncludedInSessionSample_<site_id>',
      duration: '2 minutes',
      description: `Set to determine if a user is included in the data sampling defined by your site's daily session limit`,
    },
    {
      name: '_hjAbsoluteSessionInProgress',
      duration: '30 minutes',
      description: 'Used to detect the first pageview session of a user.',
    },
    {
      name: '_hjTLDTest',
      duration: 'Session',
      description:
        // eslint-disable-next-line max-len
        'We try to store the _hjTLDTest cookie for different URL substring alternatives until it fails. Enables us to try to determine the most generic cookie path to use, instead of page hostname. It means that cookies can be shared across subdomains (where applicable). After this check, the cookie is removed.',
    },
    {
      name: '_hjClosedSurveyInvites',
      duration: '1 year',
      description:
        // eslint-disable-next-line max-len
        'Set when a user interacts with a Link Survey invitation modal. Ensures the same invite does not reappear if it has already been shown.',
    },
    {
      name: '_hjDonePolls',
      duration: '1 year',
      description:
        // eslint-disable-next-line max-len
        'Set when a user completes an on-site Survey. Ensures the same Survey does not reappear if it has already been filled in.',
    },
    {
      name: '_hjMinimizedPolls',
      duration: '1 year',
      description:
        // eslint-disable-next-line max-len
        'Set when a user minimizes an on-site Survey. Ensures that the Survey stays minimized when the user navigates through your site.',
    },
    {
      name: '_hjShownFeedbackMessage',
      duration: '1 day',
      description:
        // eslint-disable-next-line max-len
        'Set when a user minimizes or completes a Feedback widget. Ensures the Feedback widget will load as minimized if the user navigates to another page where it is set to show.',
    },
  ];

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.tenant = this.tenantService.getTenant();
  }
}
